<template>
  <form class="support-options">
    <div>
      <h5 class="text-semibold">Opções de suporte</h5>
      <h6 class="text-dark-40 fs-12">
        Configure as opções de suporte que serão disponibilizadas
      </h6>
    </div>
    <snow-switch
      v-model="chatStatusBoolean"
      label="Ativar chat online"
      class="mb-4"
    />
    <div v-if="chat.status === 'active'" class="row">
      <div
        v-for="(item, index) in chatsOptions"
        :key="index"
        class="col-lg-3 mb-4"
      >
        <div class="card-options">
          <div class="d-flex align-items-center mb-2">
            <img :src="image(item.type)" class="mr-5" />
            <h5 class="text-semibold">{{ item.title }}</h5>
          </div>
          <div
            v-if="!chat.code || chat.type !== item.type"
            class="d-flex justify-content-end"
          >
            <snow-button
              variant="gray"
              size="sm"
              text="Integrar"
              :disabled="!!chat.code"
              @click="openConfigChat(item)"
            />
          </div>
          <div v-else class="d-flex justify-content-end gap-2">
            <snow-button
              variant="gray"
              size="sm"
              text="Editar"
              @click="openConfigChat(item)"
            />
            <snow-button
              variant="danger"
              size="sm"
              text="Excluir"
              @click="removeConfigChat"
            />
          </div>
        </div>
      </div>
    </div>

    <div>
      <h5 class="text-semibold">WhatsApp de suporte</h5>
      <h5 class="text-dark-40 fs-12">
        Configure o seu WhatsApp de suporte para o caso do seu pagamento não ser
        aprovado.
      </h5>
    </div>

    <snow-switch v-model="whatsAppSupport" label="Ativar chat online" />

    <div v-if="form.whatsapp_support.status === 'active'">
      <form-group
        v-model="form.whatsapp_support.number"
        id="number"
        label="WhatsApp para suporte"
        placeholder="Número do WhatsApp"
        isPhone
        @country-changed="phoneCountryChanged"
      />
      <snow-input
        v-model="form.whatsapp_support.text"
        id="text"
        label="Mensagem de suporte"
        textarea
      />
    </div>

    <responsive-modal v-model="modalVisible" title="Código do Chat">
      <snow-input label="Código do Chat" v-model="inputsModal[0].value" />
      <div class="snow-submit-buttons mt-6">
        <snow-button
          variant="gray"
          size="lg"
          @click="cancelConfigChat"
          text="Cancelar"
        />
        <snow-button
          @click="submitConfigChat"
          :loading="loading"
          :disabled="!isModalValid"
          text="Salvar"
          size="lg"
        />
      </div>
    </responsive-modal>
  </form>
</template>

<script>
import get from "lodash/get";

export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    productId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    const chat = this.form.option_support.find(opt => opt.type !== "whatsapp");

    return {
      loading: false,
      chat: {
        id: get(chat, "id"),
        code: get(chat, "data.code"),
        type: get(chat, "type"),
        status: get(chat, "status", "inactive")
      },
      modalVisible: false,
      inputsModal: [
        {
          value: get(chat, "data.code"),
          placeholder: "Código do chat",
          id: "code",
          type: "text",
          isTextarea: false,
          index: 0
        }
      ],
      chatsOptions: [
        {
          title: "Zendesk",
          type: "zendesk",
          placeholder:
            'Parâmetro "key". Ex.: 1275d1d9-38ac-468c-aad4-d877b71705c4'
        },
        {
          title: "Intercom",
          type: "intercom",
          placeholder: "Id do Workspace."
        },
        {
          title: "Crisp",
          type: "crisp",
          placeholder:
            "CRISP_WEBSITE_ID. Ex.: b884e2d5-c9a2-4230-b33f-fd8d2213552e"
        },
        {
          title: "Facebook Chat",
          type: "facebook-chat",
          placeholder: 'Seu "page_id". Ex.: 213392751795255'
        },
        {
          title: "Octadesk Chat",
          type: "octadesk",
          placeholder: "Identificador da empresa. Ex.: ZeusPay"
        },
        {
          title: "JivoSite",
          type: "jivosite",
          placeholder: "Código do widget. Ex.: PfbeXObRSz"
        },
        {
          title: "Tawk.To",
          type: "tawkto",
          placeholder: "Property ID/Widget ID. Ex.: 51ca2b...64fdb/1r4arlpon"
        },
        {
          title: "Zopim",
          type: "zopim",
          placeholder:
            'Parâmetro "key". Ex.: 1275d1d9-38ac-468c-aad4-d877b71705c4'
        },
        {
          title: "Fresh Chat",
          type: "fresh-chat",
          placeholder:
            'Parâmetro "token". Ex.: fv5b58f9-0cbe-410a-r4dc-69iadb7t5d8e'
        },
        {
          title: "Bitrix 24",
          type: "bitrix24",
          placeholder: "Complete: https://cdn.bitrix24.com.br/[...].js"
        }
      ]
    };
  },
  computed: {
    chatStatusBoolean: {
      get() {
        return this.chat.status === "active";
      },
      set(value) {
        this.chat.status = value ? "active" : "inactive";
      }
    },
    whatsAppSupport: {
      get() {
        return this.form.whatsapp_support.status === "active";
      },
      set(value) {
        this.form.whatsapp_support.status = value ? "active" : "inactive";
      }
    },
    isValid() {
      return (
        !this.whatsAppSupport ||
        this.form.whatsapp_support.number?.trim() !== ""
      );
    },
    isModalValid() {
      return !!this.inputsModal[0].value?.trim();
    }
  },
  methods: {
    image(type) {
      return type ? require(`@/assets/images/checkout-chat/${type}.png`) : "";
    },
    openConfigChat(item) {
      this.inputsModal[0].placeholder = item.placeholder;
      this.chat.type = item.type;
      this.modalVisible = true;
    },
    removeConfigChat() {
      this.loading = true;

      this.$store
        .dispatch("optionSupport/delete", this.chat.id)
        .then(() => {
          this.$message.success(`${this.chat.type} removido com sucesso`);
          this.chat.id = null;
          this.chat.type = null;
          this.chat.code = null;
          this.inputsModal[0].value = "";
          this.$emit("remove");
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.$message.error(
              error.response.data.details ||
                "Não foi possível remover a integração"
            );
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancelConfigChat() {
      this.modalVisible = false;
      this.inputsModal[0].value = this.chat.code || "";
    },
    submitConfigChat() {
      if (!this.inputsModal[0].value?.trim()) {
        this.$message.error("Insira o código");
        return;
      }

      this.loading = true;
      let action = this.chat.id ? "optionSupport/put" : "optionSupport/post";
      this.$store
        .dispatch(action, {
          id: this.chat.id,
          product_id: this.productId,
          type: this.chat.type,
          status: this.chat.status,
          data: {
            code: this.inputsModal[0].value
          }
        })
        .then(response => {
          this.$message.success(`${this.chat.type} salvo com sucesso`);
          this.$emit("save", response.data);
          this.chat.id = response.data.id;
          this.chat.code = this.inputsModal[0].value;
          this.modalVisible = false;
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.$message.error(
              error.response.data.details ||
                "Não foi possível salvar a integração"
            );
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    phoneCountryChanged(obj) {
      this.form.whatsapp_support.ddi = obj.dialCode;
    }
  },
  watch: {
    isValid(newVal) {
      this.$emit("isValid", newVal);
    },
    whatsAppSupport(newVal) {
      if (!newVal) {
        this.form.whatsapp_support.number = "";
      }
    }
  },
  mounted() {
    this.$emit("isValid", this.isValid);
  }
};
</script>

<style lang="scss" scoped>
.support-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
  .card-options {
    background: var(--bg-5);
    border: 1px solid var(--dark-10);
    border-radius: 16px;
    padding: 24px;
  }
  ::v-deep.vue-tel-input {
    background: transparent;
    border: none;
    padding: 0px;
    gap: 8px;

    &:focus-within {
      box-shadow: none;
    }

    .vti__input,
    .vti__dropdown {
      background: var(--bg-5);
      padding: 20px 16px;
      border-radius: 16px;
      border: 0.5px solid var(--dark-10);
      transition: all 0.2s ease-in-out;

      &:hover {
        border-color: var(--dark-40) !important;
      }

      &:focus-within {
        border-color: var(--dark-40);
        box-shadow: 0px 0px 0px 4px rgba(0, 0, 0, 0.05);
      }
    }

    .vti__dropdown-list {
      min-height: 100px;
      max-width: 300px;
      border-radius: 16px;
      padding: 16px;
      top: 60px;
      overflow-x: hidden;
      max-height: 200px;
      overflow-y: auto;

      @media screen and (max-width: 350px) {
        max-width: 250px;
      }
      &::-webkit-scrollbar {
        background: transparent;
      }

      .vti__dropdown-item {
        border-radius: 8px;
      }
    }
  }
}
</style>
